import React from 'react';
import { NavLink } from 'react-router-dom';
import './header.css';
import { IoHomeOutline } from "react-icons/io5";
import { IoPersonOutline } from "react-icons/io5";
import { AiOutlineFundProjectionScreen } from "react-icons/ai";
import { FaRegFileAlt } from "react-icons/fa";

function Header() {
  return (
    <nav className="navbar navbar-expand-lg" style={{backgroundColor:"#1a1328"}}>
      <div className="container-fluid">
        <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNavDropdown" aria-controls="navbarNavDropdown" aria-expanded="false" aria-label="Toggle navigation">
          <span className="navbar-toggler-icon"></span>
        </button>
        <div className="collapse navbar-collapse " id="navbarNavDropdown">
          <div className='d-flex mx-md-auto justify-content-center'>
          <ul className="navbar-nav  mb-lg-0 fs-4 text-white my-2">
            <li className="nav-item mx-2 ">
              <IoHomeOutline className='mb-2'/>
              <NavLink className="text-decoration-none text-white mx-2" to="/">Home</NavLink>
            </li>
            <li className="nav-item mx-2">
              <IoPersonOutline className='mb-2'/>
              <NavLink className="text-decoration-none text-white mx-2" to="/about">About</NavLink>
            </li>
            <li className="nav-item mx-2">
              <AiOutlineFundProjectionScreen className='mb-1'/>
              <NavLink className="text-decoration-none text-white mx-2" to="/projects">Projects</NavLink>
            </li>
            <li className="nav-item mx-2">
              <FaRegFileAlt className='mb-2'/>
              <NavLink className="text-decoration-none text-white mx-2" to="/resume">Resume</NavLink>
            </li>
          </ul>
          </div>
        </div>
      </div>
    </nav>
  );
}

export default Header;
